import { combineReducers } from 'redux';

import { MainReducer } from './mainReducer';

export const AppReducer = combineReducers({
  main: MainReducer
});



// WEBPACK FOOTER //
// ./src/business-logic/state/reducers/AppReducer.js